import { sportsOptionsStore } from '../stores';

import { queryToForm } from './';

export const setSportOptions = (sportValues: DropdownItemType[]) => {
  sportsOptionsStore.setValue(sportValues);
  queryToForm();
};
